import { gql } from "@apollo/client";

export const GET_ALL_PUBLIC_IPS = gql`
  query GetAllVmsWithPublicIp {
    getAllVmsWithPublicIp {
      id
      vmName
      ipAddress
      domainName
      billingType
    }
  }
`;

export const UPDATE_VM_DOMAIN_NAME = gql`
  mutation UpdateVmDomainName($vmId: ID!, $domainName: String!) {
    updateVmDomainName(vmId: $vmId, domainName: $domainName)
  }
`;

export const UPDATE_VM_BILLING_TYPE = gql`
    mutation UpdateVmBillingType($vmId: ID!, $billingType: String!) {
        updateVmBillingType(vmId: $vmId, billingType: $billingType)
    }
`;